import { Box, styled } from '@mui/material';

import CustomButton from 'components/CustomButton';
import CustomInput from 'components/CustomInput';

export const ItemDetailsInput = styled(CustomInput)(({ theme }) => ({
  margin: theme.spacing(1, 1),
  '& .MuiOutlinedInput-input': {
    padding: theme.spacing(0.25, 0),
    margin: theme.spacing(0, 2),
  },
}));

export const ModalContainer = styled(Box)(({ theme }) => ({
  width: '600px',
  minHeight: '200px',
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.secondary,
  gap: theme.spacing(1),
  display: 'flex',
  flexDirection: 'column',
}));

export const TitleRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: theme.spacing(1),
}));

export const TitleWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: theme.palette.background.main,
  padding: theme.spacing(2),
}));

export const BatchWrapper = styled(Box)(({ theme }) => ({
  maxHeight: '280px',
  overflowY: 'auto',
  pr: theme.spacing(1),
  backgroundColor: theme.palette.background.secondary,
}));

export const BatchCart = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  borderBottom: `4px solid ${theme.palette.background.secondary}`,
  backgroundColor: theme.palette.background.main,
  padding: theme.spacing(2),
}));

export const BatchCartDetailsBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: theme.spacing(3),
}));

export const BatchCartInputsBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
}));

export const AddBatchButton = styled(CustomButton)(({ theme }) => ({
  width: '100%',
  padding: theme.spacing(1),
  marginTop: theme.spacing(1),
}));

export const CloseButton = styled(CustomButton)(() => ({
  width: '33%',
}));
